import { Link } from "react-router-dom";
import { Activity, ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { SITE } from "@/lib/site";

const TherapyPreview = () => {
    const { t } = useLanguage();
    const P = t.previews.therapy;

    return (
        <section
            id="therapy-preview"
            data-testid="therapy-preview-section"
            className="py-24 md:py-28 bg-ella-cream relative overflow-hidden"
        >
            <div className="absolute -top-32 right-0 w-[480px] h-[480px] rounded-full bg-[radial-gradient(circle_at_center,rgba(193,154,107,0.10),transparent_60%)] pointer-events-none" />

            <div className="ella-container relative">
                <div className="grid lg:grid-cols-12 gap-12 items-center">
                    <div className="lg:col-span-6 order-2 lg:order-1">
                        <div className="inline-flex items-center gap-3">
                            <span className="gold-hairline" />
                            <span className="ella-overline" data-testid="therapy-preview-overline">
                                {P.overline}
                            </span>
                        </div>
                        <h2
                            className="ella-headline text-4xl md:text-5xl mt-4 text-ella-ink"
                            data-testid="therapy-preview-title"
                        >
                            {P.title}
                        </h2>
                        <p className="mt-5 text-ella-ink/70 font-light text-base leading-relaxed max-w-md">
                            {P.lead}
                        </p>

                        <Link
                            to="/dorn-breuss"
                            data-testid="therapy-preview-cta"
                            className="inline-flex items-center gap-3 mt-7 px-7 py-3.5 rounded-full bg-ella-ink text-ella-cream hover:bg-ella-gold-dark transition-colors text-xs uppercase tracking-[0.24em]"
                        >
                            <Activity className="w-4 h-4" strokeWidth={1.5} />
                            {P.cta}
                            <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
                        </Link>
                    </div>

                    <div className="lg:col-span-6 order-1 lg:order-2">
                        <div className="relative">
                            <div className="absolute -inset-2 rounded-[2rem] bg-gradient-to-br from-ella-gold/30 to-ella-ink/10 blur-xl opacity-60" />
                            <div className="relative aspect-[5/4] rounded-[1.75rem] overflow-hidden border border-ella-line shadow-[0_24px_60px_rgba(31,29,28,0.12)]">
                                <img
                                    src={SITE.images.therapy || SITE.images.consultation}
                                    alt={P.title}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <div className="absolute -bottom-5 -left-4 bg-white border border-ella-line rounded-2xl px-5 py-3.5 shadow-md">
                                <p className="ella-overline">CHF · Sitzung</p>
                                <p className="font-display text-3xl text-ella-ink leading-none mt-1">
                                    185
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TherapyPreview;
